import { useContext } from 'react';
import { NewSizeGuideContext } from './NewSizeGuideContext';

export const useNewSizeGuideContext = () => {
  const context = useContext(NewSizeGuideContext);

  if (context === undefined) {
    throw new Error(
      'useNewSizeGuideContext must be used within a NewSizeGuideContext.Provider',
    );
  }

  return context;
};
